import BaseService from "@/services/BaseService";

export default class TermsService extends BaseService {

    static async uploadTerms(base64: string) {
        return await this.perform({
            url: "/portal/terms",
            method: "POST",
            auth: true,
            body: {
                base64: base64
            }
        });
    }

}
